import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions/churgerBuilderActions';

import Churger from '../components/ChurgerBuilder/Churger';
import ChurgerControls from '../components/ChurgerBuilder/ChurgerControls/ChurgerControls';

export default function ChurgerBuilder() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(actions.setPage('order'));
	});

	return (
		<div id="Order">
			<Churger />
			<ChurgerControls />
		</div>
	);
}
